<script setup lang="ts">
/**
 * Hängt den globalen Toast-Bus (`@/composables/toast`) an PrimeVues
 * `ToastService`, damit auch Router-Guards Meldungen auslösen können.
 */
import Toast from 'primevue/toast'
import { useToast as usePrimeToast } from 'primevue/usetoast'
import { onBeforeUnmount, onMounted } from 'vue'

import { registerToastSink, unregisterToastSink, type ToastMessage } from '@/composables/toast'

const primeToast = usePrimeToast()

function sink(message: ToastMessage): void {
  primeToast.add({
    severity: message.severity,
    summary: message.summary,
    detail: message.detail,
    life: message.life,
  })
}

onMounted(() => registerToastSink(sink))
onBeforeUnmount(() => unregisterToastSink(sink))
</script>

<template>
  <Toast position="top-right" class="app-shell__toast" />
</template>
